export default "__VITE_ASSET__JHL3gtkP__"